//React Query Default Options
export default {
  queries: {
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false,
    retry: 1
  }
};
